import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    Type
} from '@angular/core';

@Component({
    selector: 'app-info-label',
    templateUrl: './info-label.component.html',
    styleUrls: ['./info-label.component.css']
})
export class InfoLabelComponent implements OnInit {
    @Input() lable?: string;
    @Input() info?: string;
    @Input() lable2?: string;
    @Input() info2?: string;
    @Input() icon?: string;
    @Input() percentage?: string = null;
    @Input() isCheckable = false;
    @Input() isChecked = false;
    @Input() vertical = false;
    @Input() arcColor = '#0E6461';
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onCheckChange = new EventEmitter<boolean>();
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onCheckChange1 = new EventEmitter<Event>();
    circleRadius: number = 30;

    constructor() {}


    ngOnInit() {
        
      }
      
      calculateDimensions() {
        const width = window.innerWidth;
        let radius: number;
        let translateY: number;
      
        if (width <= 600) {
          radius = 15;
          translateY = 17;   
        } else if (width <= 1024) {
          radius = 20;
          translateY = 17;  
        } else {
          radius = 30;
          translateY = 455;   
        }
      
        return { radius, translateY };   
      }

      getDimensions() {
        const { radius, translateY } = this.calculateDimensions();
        return { radius, translateY };
      }

    getNumPerc() {
        return this.percentage ?? '0';
    }
}
